import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Button, Pagination, Message, 
  Loading, Empty, Dialog, Form, Input, FormItem, 
  Upload, Select, Option ,Checkbox} from 'element-ui';
import store from './store'
import { getUsername, getCode, signUp, Login } from "@/api/user"
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Form)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Dialog)
// Vue.use(Message)
Vue.config.productionTip = false
async function test() {
  // const res=await getUsername('aaa')
  // console.log(res);

  // const res=await getCode({
  //   phone:"17628094212",
  //   reason:"sign-up",
  //   mock: true
  // })

  //   const res=await signUp({
  //     phone_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzeGRhdGEiLCJzdWIiOiJzb21lYm9keSIsImV4cCI6MTczNzAwOTg2NywibmJmIjoxNzM0NDE3ODY3LCJpYXQiOjE3MzQ0MTc4NjcsIm1vYmlsZV9waG9uZSI6IjE3NjI4MDk0MjY2IiwiaXAiOiIxMTguMTIxLjE0OS42NSIsInZlcmlmaWNhdGlvbl9jb2RlIjoiMTExMTExIn0.4EEV8_orYL-GCcmEm9TTgreKmS-Y6mtWbBo8Gi8gilU"
  //     ,phone: "17628094266",
  //     verification_code: "111111",
  //     username: "Alex2",
  //     password: "123456"
  // })
  // const res=await Login({
  //       login_type: 2,
  //       username: "Alex3",
  //       password: "654321"
  // })
  // localStorage.setItem('token',`Bearer ${res.access_token}`)

}
window.getUsername = test
test()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
